import { useState } from "react";
import Modal from "../../../../../components/base/Modal";
import Job from "../../models/Job";
import { closeJobQuickView, useGlobal, useHub } from "../../../../../core/Global";
import { API_ROUTES } from "../../../../../core/Constants";

interface IProps {
    job: Job
}
export default function JobRejectByTechModal(props: IProps) {

    const hub = useHub()
    const [globalState, globalStateSet] = useGlobal()

    return (
        <Modal id="modal-rejectbytech-confirm"
            title="Reject Job"
            subtitle={"Job ID: " + props.job.jobId + " | " + props.job.fullName}
            visible open
            buttonText="Confirm & Reject"
            buttonColor="danger"
            onClose={() => {
                globalStateSet({
                    rejectJobByTech: undefined
                })
            }}
            onSubmit={(body, callback) => {

                hub.Post(API_ROUTES.Jobs + "rejectbytech", {
                    id: props.job.id
                }, res => {
                    callback?.(res)
                    window.closeJobDrawer()
                })

            }}>

            <div>
                Are you sure you want to reject the job?
            </div>

        </Modal>
    )
}